module.exports = __webpack_public_path__ + "static/media/axel2_bg.69880b57.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/axel2_bg.gif
// module id = 249
// module chunks = 0